import axios from "axios";

const fetchLogs = (params, config) => {
  return axios.get(`/api/v1/action_logs`, {
    params,
    ...config,
  });
};

const fetchEvents = () => {
  return axios.get(`/api/v1/action_logs/events_list`);
};

const ApiDigiaLogs = {
  fetchLogs,
  fetchEvents,
};

export default ApiDigiaLogs;
